import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import { MdCreate } from "react-icons/md";
import { DisplaySpinnerContext, TabPanelContext } from "../../../../context/ContextIndex";
import DataGridRange from "../../../../components-old/elements/DataGridRange/DataGridRange";
import GridAction from "../../../../components-old/elements/GridAction/GridAction";
import ButtonGroup from "../../../../components-old/elements/ButtonGroup/ButtonGroup";
import { Checkbox } from "@mui/material";
import { IsLoggedInUserViewer } from "../../../../hoc/withAuthRedirect";

const PezodeProductList = ({ onAddClick, setShowForm }) => {
    const _tabContextObject = useContext(TabPanelContext);
    const _tabContext = _tabContextObject.getTabFormContext();

    const spinnerCtx = useContext(DisplaySpinnerContext);

    const { t } = useTranslation();

    const [pezodeProductRecordList, setPezodeProductRecordList] = useState([]);
    const [dataGridPageSize, setDataGridPageSize] = useState(10);
    const [totalPezodeProduct, setTotalPezodeProduct] = useState(0);
    const [gridPageSizeOptions] = useState([10, 20, 50]);

    // Set pezode product after fetching or directly for non-edit cases
    const setPezodeProductList = (consumableProductList) => {

        consumableProductList.sort((a, b) => new Date(b.ModifiedDate).getTime() - new Date(a.ModifiedDate).getTime());
        let _consumableProductList = consumableProductList.map((item, index) => {
            return {
                id: index,
                productName: item?.ConsumableProduct?.label,
                productPerDevice: item.ProductPerDevice,
                pezodeProductMapId: item.PezodeProductMapId,
                recordResponse: { ...item, Deleted: false },
                deleted: false,
            };
        });

        setPezodeProductRecordList(_consumableProductList);
        setTotalPezodeProduct(_consumableProductList.length);
        spinnerCtx.setLoadingIndicator(false);
    };

    useEffect(() => {
        const consumableproductmap = _tabContext.data?.consumableproductmap || [];
        if (consumableproductmap.length > 0) setPezodeProductList(consumableproductmap);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleEditPezodeProductClick = (data) => {
        _tabContextObject.setTabFormContext({
            data: {
                ..._tabContext.data,
                selectedPezodeProduct: data.recordResponse,
            },
        });

        setShowForm(true);
    };

    const handleDeletePezodeProduct = (data, selectionStatus) => {
        try {
            const _gridRecordList = pezodeProductRecordList.map(item => {
                if (item.id === data.id) {
                    return {
                        ...item,
                        deleted: selectionStatus,
                        recordResponse: {
                            ...item.recordResponse,
                            Deleted: selectionStatus,
                        },
                    };
                }
                return item;
            });

            const _prezodeProductList = _gridRecordList.map(item => {
                return item.recordResponse;
            });

            setPezodeProductRecordList(_gridRecordList);
            _tabContextObject.setTabFormContext({
                data: {
                    ..._tabContext.data,
                    consumableproductmap: _prezodeProductList,
                },
                isDirty: true
            });
        } catch (err) {
            alert(err);
        }
    };

    const handlePageSizeChange = (newPageSize) => {
        setDataGridPageSize(newPageSize);
    };

    const actionConfigs = [
        {
            icon: MdCreate,
            onClick: handleEditPezodeProductClick,
            buttonColor: "#EEEEE",
            action: "edit",
        },
    ];

    const buttonConfigs = [
        {
            buttonText: <AddIcon />,
            buttonType: "filled",
            onClick: onAddClick,
            buttonColor: "#A62B23",
            textColor: "#fff",
            action: "create",
        },
    ];

    const dataGridSchema = [
        {
            field: "productName",
            headerName: t("createProducts.productName"),
            flex: 1,
        },
        {
            field: "productPerDevice",
            headerName: t("createProducts.productPerDevice"),
            flex: 1,
        },
        !IsLoggedInUserViewer() && {
            field: "deleted",
            headerName: "Mark for Delete",
            flex: 1,
            sortable: false,
            renderCell: (params) => (
                <Checkbox defaultChecked={false} onChange={(e) => handleDeletePezodeProduct(params.row, e.target.checked)} />
            ),
        },
        {
            field: "action",
            headerName: t,
            flex: 1,
            sortable: false,
            renderCell: (params) => <GridAction actionsConfig={actionConfigs} row={params.row} />,
        },
    ];

    return (
        <>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ fontWeight: "bold", height: "30px" }}>{t("navigationMenu.products")}</div>
                <ButtonGroup buttons={buttonConfigs} />
            </div>

            <DataGridRange
                rows={pezodeProductRecordList}
                columns={dataGridSchema}
                pageSize={dataGridPageSize}
                pageSizeOptions={gridPageSizeOptions}
                onPageSizeChange={handlePageSizeChange}
                totalRowCount={totalPezodeProduct}
                toolbarHeader=""
                toolbarFilterPlaceholder={t("quoteApproval.toolbarFilterPlaceholder")}
            />
        </>
    );
};

export default PezodeProductList;
